// extracted by mini-css-extract-plugin
export default {"tableWrapper":"tablestyle_tableWrapper__u8-fW"};